import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { GetCareNowFormatService } from '../../../utilities/getcarenow-format.service';
import { environment } from '../../../../../environments/environment';
import { MonitoringService } from '../../../../shared/services/monitoring/monitoring-service';

@Component({
  selector: 'app-virtual-urgent-care-option-card-mobile',
  imports: [CommonModule, TranslateModule, MatCardModule, MatButtonModule],
  templateUrl: './virtual-urgent-care-option-card.component.html',
  styleUrls: ['../../../../../styles.css']
})
export class VirtualUrgentCareOptionCardComponent {
  @Input() providerId!: string;
  @Input() specialtyId!: string;
  @Input() name!: string;
  @Input() specialties!: string;
  @Input() availability!: string;
  @Input() photo!: string;
  @Input() websiteUrl: string | null = null;
  @Input() locale: string | null = null;

  private getCareNowFormatService: GetCareNowFormatService;

  public soonAsText: string = 'AS_SOON_AS';
  public virtualVisitText: string = 'DESCRIPTION';
  public scheduleText: string = 'SCHEULE';
  public today: string = 'TODAY';
  public tomorrow : string = 'TOMORROW';  
  public waitTime: string = '';

  constructor(private translate: TranslateService, private monitoringService: MonitoringService) {
    this.translate.use(sessionStorage.getItem("locale") || 'en-US'); // Default to 'en-US' if no locale is provided
    this.getCareNowFormatService = new GetCareNowFormatService(this.translate);
  }
  

  ngOnInit(): void {

    this.waitTime = this.getCareNowFormatService.formatNextAvailability(this.availability);

   this.translate.get('BOOK_AS_SOON_AS').subscribe((translated: string) => {
      this.soonAsText = translated;
    });

    this.translate.get('VIRTUAL_VISIT').subscribe((translated: string) => {
      this.virtualVisitText = translated;
    });

    this.translate.get('SCHEDULE').subscribe((translated: string) => {
      this.scheduleText = translated;
    });
  }

  bookNow() {
    const eptID = sessionStorage.getItem("eptID");
    const isMobile = window.location.href.includes('mobile');

    if (eptID == null || eptID == undefined || eptID == "") {
      this.bookNowUnAuth(isMobile); 
    } 
    else {
      this.bookNowAuth();
    }  
  }

  bookNowUnAuth(isMobile: boolean) {
    // mobile deeplink --> mymemorialcare://openscheduling/standalone?id=7000892&vt=52216,52220
    var deeplink = isMobile ? environment.mobile_open_scheduling_deep_link_base_url : environment.web_open_scheduling_deep_link_base_url; 
    
    deeplink += "/standalone?id=" + this.providerId
      + "&vt=" + environment.adult_vuc_rfv_id
      + "&linksource=PLUAVUC";
      
    this.monitoringService.logEvent('Schedule/NoAuth', { feature: 'get-care-now', subfeature: 'VUC', platform: 'web' }); // log as web event
    
    console.log("VUC Now clicked (IPUC)");
    console.log(deeplink);
    window.location.href = deeplink;
  }

  bookNowAuth() {
    var deepLink = "";
    const isPlus = sessionStorage.getItem("isPlus") != null ? sessionStorage.getItem("isPlus") === 'true'  : null;
    const age = sessionStorage.getItem("age");
    var ageNumber = age ? parseInt(age) : null;

    // use On My Way deep link for generic provider scheduling
    if (isPlus == null) {

      deepLink = environment.web_scheduling_deep_link_base_url;

      this.monitoringService.logEvent('Schedule', { feature: 'get-care-now', subfeature: 'VUC', platform: 'web'}); // log as web event

    } else {
      deepLink = isPlus 
      ? environment.mobile_scheduling_deep_link_base_url // For Plus users, use the mobile deep link
      : environment.epic_scheduling_deep_link_base_url; //  For non-Plus users, use the epic deep link

      var mobilePlatform = isPlus ? 'mobile-plus' : 'mobile-standard';
      this.monitoringService.logEvent('Schedule', { feature: 'get-care-now', subfeature: 'VUC', platform: mobilePlatform}); // log as mobile or web event
    }

    deepLink += "?workflow=NewProvider&selProvId=" + this.providerId;
        
    // add provider id and reason for visit id params to the deep link
    if (ageNumber != null) {
      deepLink += ageNumber < 18 
        ? "&selRfvId="+ environment.pediatric_vuc_rfv_id
        : "&selRfvId="+ environment.adult_vuc_rfv_id;
    }
      
    if (this.specialtyId && this.specialtyId.trim() !== "") {
        deepLink += `&selSpecialtyId=${this.specialtyId}`;
    }
        
    deepLink += "&linksource=AUTHVUCSCHED";

    console.log("book now clicked (VUC)");
    console.log(deepLink);
      
    window.location.href = deepLink;
  }

  formatNextAvailability(availability: string): string {
    return this.getCareNowFormatService.formatNextAvailability(availability);
  }
}
